import React from "react";
import {Breadcrumbs} from "@mui/material";
import ShareButton from "@/features/share-article/ui/ShareButton";
import {formatDMY} from "@/shared/lib/date";
import {useArticleStore} from "@/Stores/Site/Article";
import BaseLayout from "@/Layouts/BaseLayout";
import Svg from "@/Components/Svg";
import Link from "@/Layouts/Link";
import BlockRenderer from "@/widgets/editor/ui/BlockRenderer";
import NewsCarousel from "@/widgets/article/ui/NewsCarousel";
import "@/Scss/Site/NewsDetailed/index.scss";

const Index = (props) => {
    const {newsDataDetails = {}, isMobile = false} = props;
    const {news = {}, newsFromSameCategory = []} = newsDataDetails;
    const {body = {}, category = '', published_at, h1 = '', prevUrl = '', nextUrl = ''} = news;
    const {blocks = []} = body;

    const categoryId = useArticleStore(state => state.categoryId);
    const page = useArticleStore(state => state.page);

    return <BaseLayout {...props}>
        <section className={`section`}>
            <div className={`container`}>
                <div className={`newsPageDetailed`}>
                    <Breadcrumbs className={`breadcrumbs`} maxItems={3} itemsAfterCollapse={2}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <Link className={`breadcrumbs__link`} href={`/news`}>Новости</Link>
                        <p className={`breadcrumbs__text`}>{h1}</p>
                    </Breadcrumbs>
                    <div className={`newsPageDetailed__article`}>
                        <h1 className={`h1`}>{h1}</h1>
                        <div className={`newsPageDetailed__nav`}>
                            <Link
                                href={`/news`}
                                method={`post`}
                                as={'button'}
                                data={{
                                    categoryId,
                                    page
                                }}
                                className={`newsPageDetailed__link`}
                            >
                                <Svg id={`arrows-left`} className={`svg__back-arrow`} />
                                Назад к списку
                            </Link>
                            <p>{formatDMY(published_at)}</p>
                        </div>
                        <div className={`newsPageDetailed__category`}>
                            <p className={`newsPageDetailed__categoryName`}>{category}</p>
                            <div className={`newsPageDetailed__share`}>
                                <ShareButton text={h1} isMobile={isMobile} />
                            </div>
                        </div>
                        <div className={`newsPageDetailed__body`}>
                            {blocks.map((block, i) => (
                                <BlockRenderer key={i} block={block} />
                            ))}
                        </div>
                        <div className={`newsPageDetailed__nav`}>
                            {prevUrl ?
                                <Link href={`${prevUrl}`} className={`link`}>
                                    <Svg id={`arrows-left`} className={`svg__blog-arrow-back`} />
                                    Предыдущая
                                </Link>
                                :
                                <div className={`link`}></div>
                            }
                            {nextUrl ?
                                <Link href={`${nextUrl}`} className={`link`}>
                                    Следующая
                                    <Svg id={`arrows-right`} className={`svg__blog-arrow-forward`} />
                                </Link>
                                :
                                <div className={`link`}></div>
                            }
                        </div>
                    </div>
                    {newsFromSameCategory.length > 0 && (
                        <div className={`newsPageDetailed__other`}>
                            <p className={`newsPageDetailed__otherTitle`}>Другие статьи рубрики</p>
                            <div className={`newsPageDetailed__otherCarousel`}>
                                <NewsCarousel data={newsFromSameCategory} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    </BaseLayout>
}

export default Index;
